import { useState, useContext } from 'react';
import { Button } from 'components/UI/Button/Button';
import { FilterLabelBox } from 'components/UI/FilterLabelBox/FilterLabelBox';
import { getSelectedSearchFilters } from 'utils';
import { SearchContext } from 'components/SearchFormAndResults/SearchFormAndResultsProvider';

import './SearchFormFilterLabels.scss';

export const SearchFormFilterLabels = () => {
  const { isLoading, searchFilters, disableAllFiltersHandler, removeSingleFilterHandler } =
    useContext(SearchContext);

  const [showActiveFilters, setShowActiveFilters] = useState();
  const clearFilterText = 'Clear selected filters';
  const selectedSearchFilters = getSelectedSearchFilters(searchFilters);

  const showFiltersOnMobileHandler = () => {
    setShowActiveFilters(!showActiveFilters);
  };

  return selectedSearchFilters?.length ? (
    <div className="search-filters__container container" data-testid="filter-labels">
      <div className="row">
        <Button
          extendClass="btn-secondary search-filters__button"
          onClick={showFiltersOnMobileHandler}
        >
          {showActiveFilters ? 'Hide' : 'Show'} active filters
        </Button>
        <div className={`search-filters__labels ${showActiveFilters ? 'show-labels' : ''}`}>
          <FilterLabelBox
            extendClass="search-filters__label"
            text={clearFilterText}
            disabled={isLoading}
            key="clear-all"
            onClickHandler={disableAllFiltersHandler}
          />
          {Object.keys(selectedSearchFilters)?.map((filter, index) => (
            <FilterLabelBox
              extendClass="search-filters__label"
              text={selectedSearchFilters[filter].description}
              disabled={isLoading}
              key={index}
              onClickHandler={() => removeSingleFilterHandler(selectedSearchFilters[filter].id)}
            />
          ))}
        </div>
      </div>
    </div>
  ) : null;
};
